// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"industries-module--wrapper--DtGQq","card":"industries-module--card--1HvM2","content":"industries-module--content--1oBij","icon":"industries-module--icon--3y_8N"};